<template>
  <div
    :id="matchedDepot ? 'showIcons' : 'editArticle' + item.srno"
    style="position: relative; float: right; visibility: hidden"
    :style="{ visibility: matchedDepot ? 'visible' : 'hidden' }"
    class="d-flex align-content-center flex-no-wrap justify-end flex-sm-grow-0"
  >
    <!-- Show Depot Icons to Depot Articles -->
    <template v-if="showDepotIcon">
      <!-- Show Depot Note  -->
      <v-tooltip bottom v-if="showDepotIcon && matchedDepot">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-on="on" v-bind="attrs" color="error" class="pl-1"
            >mdi-information</v-icon
          >
        </template>
        {{ matchedDepot }}
      </v-tooltip>
    </template>
    <template v-else>
      <!-- Show All other icons if it is not depot article -->
       
      <!-- Edit Article -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-if="!hidePencilIcon"
            v-on="on"
            v-bind="attrs"
            @click="editItem(item)"
            color="primary"
            class="pl-1"
            :class="'mdi mdi-pencil'"
          ></v-icon>
        </template>
        {{ $t("icon_group.edit_article") }}
      </v-tooltip>
      <!-- Edit Note -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-on="on"
            v-bind="attrs"
            @click="addTextAndGroupToArticle(item)"
            color="warning"
            class="pl-1"
            :class="
              item.text ? 'mdi mdi-note-edit-outline' : 'mdi mdi-note-edit'
            "
          ></v-icon>
        </template>
        {{ $t("icon_group.edit_note_article") }}
      </v-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  name: "IconGroupForArticle",
  data() {
    return {
      stockUnits: this.value,
      buttonArray: [0, 1, 2, 4],
    };
  },
  props: {
    item: [Object, String],
    hidePencilIcon: {
      type: Boolean,
      default: false,
    },
    extraData: {
      type: Object,
      default: null,
    },
    showDepotIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addTextAndGroupToArticle() {
      this.$emit("addTextAndGroupToArticle", this.item);
    },
    editItem() {
      this.$emit("editItem", this.item);
    },
    copyEan() {
      this.copyText(this.item?.article_original_name?.identifier);
    },
  },
  computed: {
    matchedDepot() {
      let matchedDepotFound = false;
      if (
        this.item &&
        this.extraData &&
        typeof this.extraData == "object" &&
        this.extraData?.depot &&
        this.extraData?.depot?.length > 0
      ) {
        (this.extraData?.depot ?? []).forEach((element) => {
          if (
            this.item.depot_in_id == element?.id ||
            this.item.depot_out_id == element?.id
          ) {
            matchedDepotFound = element?.note;
          }
        });
      }
      return matchedDepotFound;
    },
  },
};
</script>

<style scoped></style>
